import './modules';



// WEBPACK FOOTER //
// ./src/main/javascripts/main.js